<ion-card>
    <ion-input type="text" placeholder="Customer/company name..." [(ngModel)]="action.customerDTO.name"></ion-input>
    <ion-input type="text" placeholder="Address 1" [(ngModel)]="action.customerDTO.add1"></ion-input>
    <ion-input type="text" placeholder="Address 2" [(ngModel)]="action.customerDTO.add2"></ion-input>
    <ion-input type="text" placeholder="Address 3" [(ngModel)]="action.customerDTO.add3"></ion-input>
    <ion-input type="text" placeholder="Address 4" [(ngModel)]="action.customerDTO.add4"></ion-input>
</ion-card>

<ion-card>
    <ion-input type="text" placeholder="Contact name" [(ngModel)]="action.contactDTO.name" maxlength="20"></ion-input>
    <ion-input type="tel" placeholder="Phone" [(ngModel)]="action.contactDTO.phone"></ion-input>
    <ion-input type="email" placeholder="Email" [(ngModel)]="action.contactDTO.email"></ion-input>
</ion-card>
